<template>
  <div class="accountUpdatePersonalData isBackground">
    <Header :title="title" />
    <div id="content">
      <div class="layout">
        <div class="top-description">
          * 完善资料，保障您的账户安全，更可获得20元红包
        </div>
        <div>
          <div class="item">
            <span>身份证号</span>
            <div class="input-box" :class="{ focus: showIdInputTip, error: !showIdInputTip && promptMsg.idDocumentNumber != '' }">
              <input v-model="idDocumentNumber" placeholder="因监管要求，请输入您的真实身份证号码" style="width: 90%;" maxlength="18" @input="idDocumentNumber = $event.target.value.replace(invalidIdDocumentNumberRegex, '')" @focus="showIdInputTip = true" @blur="promptMsg.idDocumentNumber = ''; showIdInputTip = false;">
            </div>
            <div v-if="showIdInputTip" class="input-tip">*请输入您的身份证号</div>
            <div v-if="!showIdInputTip" class="errPrompt">{{ promptMsg.idDocumentNumber }}</div>
          </div>
          <transition name="personal-data-reveal">
            <div v-if="showOptionalEmailField" class="item">
              <span>常用邮箱（选填）</span>
              <div class="input-box" :class="{ focus: showEmailInputTip, error: !showEmailInputTip && promptMsg.email != '' }">
                <input v-model="email" autocomplete="off" placeholder="账户的重要信息将发送到您的邮箱" type="email" style="width: 90%;" @focus="showEmailInputTip = true" @blur="onEmailInputBlur">
                <ul v-if="showEmailSuggestions" class="email-suggestions-list">
                  <li v-for="emailSuggestion in emailSuggestions" :key="emailSuggestion" class="email-suggestion-item" @mousedown.prevent="selectEmailSuggestion(emailSuggestion)">
                    {{ emailSuggestion }}
                  </li>
                </ul>
              </div>
              <div v-if="showEmailInputTip" class="input-tip">
                *请输入您的常用邮箱
              </div>
              <div class="email-tip">
                使用用户中心可开启通知，包括交易提示/按金不足提示/存取款提示
              </div>
              <div class="errPrompt">{{ promptMsg.email }}</div>
            </div>
          </transition>
          <transition name="personal-data-reveal">
            <div v-if="isAccountInfoLoaded" class="submit-box" :class="{ disabled: isSubmitting }" @click="submit()">
              <span class="submit-btn" type="primary">
                {{ isSubmitting ? '提交中' : '完成' }}
                <svg v-if="isSubmitting" class="google-spinner" viewBox="25 25 50 50">
                  <circle class="google-spinner-path" cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="4" />
                </svg>
              </span>
            </div>
          </transition>
          <div class="errPrompt bottom">
            {{ promptMsg.submit }}
          </div>
        </div>
        <div class="bottom-description">
          我们将确保 100% 隐私，不会共享您的信息。
        </div>
      </div>
    </div>
    <UpdatePersonalDataWarningPopup :error-message="warningPopupErrorMessage" @onButtonPress="onWarningPopupButtonPress" />
  </div>
</template>

<script>
require('@/assets/css/accUpdatePersonalData.css')
import Header from '@/view/module/Header.vue'
import UpdatePersonalDataWarningPopup from '@/view/module/UpdatePersonalDataWarningPopup.vue'
import api from '@/plugins/api'
import { isValidAccountEmail } from '@/utils/emailValidation'
import { mapState } from 'vuex'

export default {
  name: 'AccUpdatePersonalData',
  components: { Header, UpdatePersonalDataWarningPopup },
  data() {
    return {
      title: '补充资料',
      idDocumentNumber: '',
      email: '',
      showOptionalEmailField: false,
      isAccountInfoLoaded: false,
      isSubmitting: false,
      promptMsg: {
        idDocumentNumber: '',
        email: '',
        submit: ''
      },
      invalidIdDocumentNumberRegex: /[^\dXx]/g,
      idDocumentNumberRegex: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
      minAge: 18,
      showIdInputTip: false,
      showEmailInputTip: false,
      chineseName: '',
      phone: '',
      suggestedEmailDomains: [
        'qq.com',
        '163.com',
        'sina.com',
        '126.com',
        'yahoo.com',
        'yahoo.cn'
      ],
      warningPopupErrorMessage: '',
      popupResolve: null,
      from: this.$route.query.from || ''
    }
  },
  computed: {
    ...mapState(['gts2CustomerId']),
    emailSuggestions: function() {
      if (!this.email.includes('@') || /@.+\..+$/.test(this.email)) {
        return []
      }

      const [localPart, domainPart] = this.email.split('@')

      if (!domainPart) {
        return this.suggestedEmailDomains.map(domain => `${localPart}@${domain}`)
      }

      const filteredDomains = this.suggestedEmailDomains.filter(domain =>
        domain.startsWith(domainPart.toLowerCase())
      )

      return filteredDomains.map(domain => `${localPart}@${domain}`)
    },
    showEmailSuggestions: function() {
      return this.emailSuggestions.length > 0
    }
  },
  async mounted() {
    this.$bus.$emit('loading', false)
    await this.getAccTradeInfo()
  },
  methods: {
    selectEmailSuggestion(emailSuggestion) {
      this.email = emailSuggestion
    },
    async getAccTradeInfo() {
      try {
        const res = await api.getAccTradeInfo(this.gts2CustomerId)
        if (res.data.code == 200) {
          const accountInfo = res.data.data && res.data.data.accountInfo
          if (!accountInfo) return
          this.chineseName = accountInfo.chineseName
          this.phone = accountInfo.mobilePhone
          this.showOptionalEmailField = this.isMissingEmail(accountInfo.email) &&
            this.isMissingEmail(accountInfo.emailNew)
        }
      } catch {
        this.showOptionalEmailField = false
      } finally {
        this.isAccountInfoLoaded = true
        this.$bus.$emit('loading', true)
      }
    },
    isMissingEmail(email) {
      const normalized = String(email || '').trim().toLowerCase()
      return normalized === '' ||
        normalized === 'realemail' ||
        normalized === 'systemfxservice@outlook.com'
    },
    isValidIdDocumentNumber() {
      if (!/\d{17}[\dxX]/.test(this.idDocumentNumber)) {
        return false
      }
      var modcmpl = function(m, i, n) {
        return (i + n - (m % i)) % i
      }
      var f = function(v, i) {
        return v * (Math.pow(2, i - 1) % 11)
      }
      var s = 0
      for (var i = 0; i < 17; i++) {
        s += f(+this.idDocumentNumber.charAt(i), 18 - i)
      }
      var c0 = this.idDocumentNumber.charAt(17)
      var c1 = modcmpl(s, 11, 1)
      return c0 - c1 === 0 || (c0.toLowerCase() === 'x' && c1 === 10)
    },
    getAgeFromIdDocumentNumber() {
      const idCard = this.idDocumentNumber
      var myDate = new Date()
      var month = myDate.getMonth() + 1
      var day = myDate.getDate()
      var age = myDate.getFullYear() - idCard.substring(6, 10) - 1
      if (
        idCard.substring(10, 12) < month ||
        (idCard.substring(10, 12) == month && idCard.substring(12, 14) <= day)
      ) {
        age++
      }
      return age
    },
    isValidAge() {
      return this.getAgeFromIdDocumentNumber() >= this.minAge
    },
    async isValidEmail() {
      if (this.email === '') {
        this.promptMsg.email = ''
        return true
      }

      if (!isValidAccountEmail(this.email)) {
        this.promptMsg.email = '邮箱格式不正确！'
        return false
      }

      const whiteListValidateRes = await api.whiteListValidate({ email: this.email })
      if (whiteListValidateRes.status !== 'SUCCESS') {
        const isExistedEmailRes = await api.isExistedEmail(this.email)
        if (isExistedEmailRes == 'false') {
          this.promptMsg.email = '该邮箱已存在！'
          return false
        }
      }

      if (this.email.includes('gmail')) {
        this.promptMsg.email = '请使用非gmail邮箱'
        return false
      }

      return true
    },
    async submit() {
      if (this.isSubmitting) return
      this.isSubmitting = true

      try {
        this.promptMsg = {
          idDocumentNumber: '',
          email: '',
          submit: ''
        }

        if (this.idDocumentNumber.trim() == '') {
          this.promptMsg.idDocumentNumber = '身份证号不能为空！'
          return
        }

        if (!this.idDocumentNumberRegex.test(this.idDocumentNumber.trim())) {
          this.promptMsg.idDocumentNumber = '身份证号格式不正确！'
          return
        }

        if (!this.isValidIdDocumentNumber()) {
          this.promptMsg.idDocumentNumber = '身份证不正确！'
          return
        }

        if (!this.isValidAge()) {
          this.promptMsg.idDocumentNumber = '您没到18岁！'
          return
        }

        const idDocumentNumber = this.idDocumentNumber.toUpperCase()

        const validateIdCardParams = {
          idNumber: idDocumentNumber,
          chineseName: this.chineseName,
          phone: this.phone
        }

        this.$bus.$emit('loading', false)

        const {
          data: validateIdCardResData
        } = await api.validateIdCard(this.$qs.stringify(validateIdCardParams))
        this.$bus.$emit('loading', true)

        if (validateIdCardResData.code == 500) {
          const confirm = await this.showWarningPopupWithMessage(validateIdCardResData.code_desc || validateIdCardResData.ch_msg)
          if (!confirm) {
            return
          }
        }

        if (this.showOptionalEmailField) {
          const isEmailValid = await this.isValidEmail()
          if (!isEmailValid) return
        }

        const updatePersonalDataParams = {
          idDocumentNumber: this.idDocumentNumber
        }
        if (this.showOptionalEmailField) {
          updatePersonalDataParams.email = this.email
        }

        this.$bus.$emit('loading', false)
        const {
          data: updatePersonalDataResData
        } = await api.updatePersonalData(this.$qs.stringify(updatePersonalDataParams))
        this.$bus.$emit('loading', true)

        if (updatePersonalDataResData.code == 200) {
          if (this.from && this.from != '') {
            this.$router.replace({ path: this.from })
            return
          }

          this.$router.replace({ path: '/home/recharge' })
          return
        }

        const defaultErrorMessage = '网络异常，操作失败'
        const finalErrorMessage = (updatePersonalDataResData.code_desc && typeof updatePersonalDataResData.code_desc === 'string' && updatePersonalDataResData.code_desc.length > 0)
          ? updatePersonalDataResData.code_desc
          : (updatePersonalDataResData.ch_msg && typeof updatePersonalDataResData.ch_msg === 'string' && updatePersonalDataResData.ch_msg.length > 0)
            ? updatePersonalDataResData.ch_msg
            : defaultErrorMessage

        this.promptMsg.submit = finalErrorMessage
      } catch {
        this.$bus.$emit('loading', true)
        this.promptMsg.submit = '网络异常，操作失败'
      } finally {
        this.isSubmitting = false
      }
    },
    showWarningPopupWithMessage(errorMessage) {
      this.warningPopupErrorMessage = errorMessage

      return new Promise((resolve) => {
        this.popupResolve = resolve
      })
    },
    onWarningPopupButtonPress(actionId) {
      this.warningPopupErrorMessage = ''

      if (actionId == 'reset') {
        this.idDocumentNumber = ''
        this.email = ''
        if (this.showOptionalEmailField) this.onEmailInputBlur()
        this.popupResolve(false)
        return
      }

      if (actionId == 'acknowledge') {
        this.popupResolve(false)
        return
      }

      this.popupResolve(true)
    },
    onEmailInputBlur() {
      this.showEmailInputTip = false
      return this.isValidEmail()
    }
  }
}
</script>
